module.exports = __webpack_public_path__ + "assets/img/thumb-Coolabah-Turf-Article.ce80c01c.jpg";